// extracted by mini-css-extract-plugin
export default {"kidTestimonialsBox":"KidTestimonials_kidTestimonialsBox__xz+86","kidTesti":"KidTestimonials_kidTesti__uZGUT"};